import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import UpcomingEvent from '@/components/sections/right/upcoming-event';
import { Event } from '@/types/article-type';

type UpcomingEventsProps = {
    className?: string;
    title: string;
    events?: Event[];
};

const UpcomingEvents = (props: UpcomingEventsProps) => {
    const { title, className, events = [] } = props;
    if (events.length === 0) return null;

    return (
        <div className={cn('divide-y border-y', className)}>
            <div className="flex justify-start items-center px-10 py-5 w-full">
                <div className="gap-2.5">
                    <p className="font-semibold text-left uppercase text-dark">{title}</p>
                </div>
            </div>
            {events.map(event => (
                <UpcomingEvent
                    key={event.slug}
                    className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0"
                    title={event.title}
                    description={event.excerpt}
                    location={event.customFields?.location || ''}
                    date={event.customFields?.text_date || ''}
                    learnMoreUrl={`/event/${event.slug}`}
                    registerUrl={
                        event.customFields.registration_button_link?.url ||
                        event.customFields.header_button_1_link?.url ||
                        ''
                    }
                />
            ))}
        </div>
    );
};

export default UpcomingEvents;
